// Exposes jQuery as $ and jQuery globals — mirrors browserify-shim behavior
import $ from 'jquery';
window.$ = $;
window.jQuery = $;
